/** Opening/closing balance lines — consolidated view only (hidden at single-hospital scope). */
export const CF_CONSOLIDATED_ONLY_LINE_IDS = [
  'CF1',
  'CF2',
  'CF3',
  'CF4',
  'CF25',
  'CF26',
  'CF27',
  'CF28',
] as const;

/** Manually overridable opening/closing lines (consolidated scope only). */
export const CF_CONSOLIDATED_EDITABLE_LINE_IDS = [
  'CF1',
  'CF2',
  'CF3',
  'CF25',
  'CF26',
  'CF27',
] as const;

const CONSOLIDATED_ONLY = new Set<string>(CF_CONSOLIDATED_ONLY_LINE_IDS);
const CONSOLIDATED_EDITABLE = new Set<string>(CF_CONSOLIDATED_EDITABLE_LINE_IDS);

export function isCashFlowLineVisible(lineId: string, isConsolidated: boolean): boolean {
  return isConsolidated || !CONSOLIDATED_ONLY.has(lineId);
}

export function isCashFlowLineEditable(
  lineId: string,
  canEdit: boolean,
  isConsolidated: boolean
): boolean {
  if (!canEdit) return false;
  if (CONSOLIDATED_ONLY.has(lineId)) {
    return isConsolidated && CONSOLIDATED_EDITABLE.has(lineId);
  }
  return true;
}
